var _path, _rect, _rect2, _rect3, _rect4, _path2, _rect5, _rect6, _rect7, _rect8, _path3, _rect9, _rect10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAgreementServiceMainMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 93,
    viewBox: "0 0 114 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.9033 30.1426L80.2531 23.6313C82.686 23.1701 85.0705 24.6354 85.7582 27.0143L92.3389 49.7772C94.18 56.146 91.1608 62.9144 85.1918 65.7992L55.3923 80.2011L45.9033 30.1426Z",
    fill: "#EEC2B9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41.6025,
    y: 25.9482,
    width: 64.1887,
    height: 10.7263,
    rx: 4.8,
    transform: "rotate(33.2866 41.6025 25.9482)",
    fill: "#FFDCD5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 35.708,
    y: 34.9092,
    width: 61.9498,
    height: 11.6202,
    rx: 4.8,
    transform: "rotate(33.2866 35.708 34.9092)",
    fill: "#FFDCD5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29.3242,
    y: 44.6182,
    width: 57.0675,
    height: 10.7263,
    rx: 4.8,
    transform: "rotate(33.2866 29.3242 44.6182)",
    fill: "#FFDCD5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.4307,
    y: 53.5791,
    width: 54.2998,
    height: 10.7263,
    rx: 4.8,
    transform: "rotate(33.2866 23.4307 53.5791)",
    fill: "#FFDCD5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.857 25.4009C35.3476 23.1371 38.4158 22.5557 40.6313 24.1172L61.4753 38.8088C63.5938 40.3019 64.1443 43.2072 62.719 45.3718L43.5167 74.5348C42.0261 76.7986 38.9579 77.38 36.7424 75.8185L15.8984 61.1269C13.7799 59.6338 13.2294 56.7285 14.6547 54.5638L33.857 25.4009Z",
    fill: "#FFDCD5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 33.9238,
    y: 65.7246,
    width: 9.83245,
    height: 17.6989,
    rx: 3.2,
    transform: "rotate(33.0034 33.9238 65.7246)",
    fill: "#EEC2B9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 25.7393,
    y: 60.2773,
    width: 9.83245,
    height: 14.3017,
    rx: 3.2,
    transform: "rotate(33.0034 25.7393 60.2773)",
    fill: "#EEC2B9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 50.2939,
    y: 76.6201,
    width: 9.83245,
    height: 12.9079,
    rx: 3.2,
    transform: "rotate(33.0034 50.2939 76.6201)",
    fill: "#EEC2B9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 42.1094,
    y: 71.1719,
    width: 9.83245,
    height: 15.3009,
    rx: 3.2,
    transform: "rotate(33.0034 42.1094 71.1719)",
    fill: "#EEC2B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.214 30.651L67.4197 26.0626L62.3365 37.2004L47.7345 39.8017L42.3152 49.6279C40.7663 52.4363 37.3779 53.6646 34.3891 52.5011L34.0028 52.3506C32.7618 51.8675 32.1515 50.4665 32.6427 49.2288L38.4573 34.5781C39.2658 32.541 41.0606 31.0592 43.214 30.651Z",
    fill: "#EEC2B9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 78.4854,
    y: 15.9844,
    width: 19.6649,
    height: 51.6776,
    rx: 3.2,
    transform: "rotate(-18.9457 78.4854 15.9844)",
    fill: "#374969"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 19.6649,
    height: 51.6776,
    rx: 3.2,
    transform: "matrix(-0.818407 -0.574639 -0.574639 0.818407 44.9268 21.4795)",
    fill: "#F5F5F5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAgreementServiceMainMobile);
export default __webpack_public_path__ + "static/media/IcAgreementServiceMainMobile.93fcb2985023ef2f11af425e06250e68.svg";
export { ForwardRef as ReactComponent };